import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { filter, length } from '../../../core/utils/collection.utils';

/**
 * Two-column assignment control. Fully controlled: the owner keeps the assignment and passes
 * it back down, so this component holds no list state of its own — `available` is derived as
 * `items` minus `assigned`. Items are compared by identity, so both inputs must be slices of
 * the same array.
 */
@Component({
  selector: 'app-transfer-list',
  templateUrl: './transfer-list.component.html',
  styleUrls: ['./transfer-list.component.css']
})
export class TransferListComponent implements OnChanges {
  @Input() items: any[] = [];
  @Input() assigned: any[] = [];
  @Input() labelProperty = 'name';
  @Output() assignedChange = new EventEmitter<any[]>();

  private selectedToAdd: any[] = [];
  private selectedToRemove: any[] = [];

  get available() {
    return filter(item => !this.assigned.includes(item), this.items);
  }

  get addEnabled() {
    return length(this.selectedToAdd);
  }

  get removeEnabled() {
    return length(this.selectedToRemove);
  }

  ngOnChanges() {
    this.selectedToAdd = [];
    this.selectedToRemove = [];
  }

  getLabel(item: any) {
    return (item) ? item[this.labelProperty] : '';
  }

  isSelectedToAdd(item: any) {
    return this.selectedToAdd.includes(item);
  }

  toggleSelectionToAdd(item: any) {
    this.selectedToAdd = (this.isSelectedToAdd(item))
      ? filter(selected => selected !== item, this.selectedToAdd)
      : [ ...this.selectedToAdd, item ];
  }

  isSelectedToRemove(item: any) {
    return this.selectedToRemove.includes(item);
  }

  toggleSelectionToRemove(item: any) {
    this.selectedToRemove = (this.isSelectedToRemove(item))
      ? filter(selected => selected !== item, this.selectedToRemove)
      : [ ...this.selectedToRemove, item ];
  }

  addSelection() {
    this.assignedChange.emit([ ...this.assigned, ...this.selectedToAdd ]);
  }

  removeSelection() {
    this.assignedChange.emit(filter(item => !this.selectedToRemove.includes(item), this.assigned));
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/shared/components/transfer-list/transfer-list.component.ts